const DEVICE_ID_KEY = "discus.v2.device-id";

interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export function getOrCreateDeviceId(
  storage: StorageLike | undefined = typeof localStorage === "undefined" ? undefined : localStorage,
  idSource: () => string = () => crypto.randomUUID(),
): string {
  if (!storage) {
    return `ephemeral-${idSource()}`;
  }

  const existing = storage.getItem(DEVICE_ID_KEY)?.trim();
  if (existing) return existing;

  const created = idSource();
  storage.setItem(DEVICE_ID_KEY, created);
  return created;
}
